module.exports = __webpack_public_path__ + "img/open-eye.22a4ae0c.svg";